import React from 'react';
import { ComplementaryServiceCategoryState } from '../../../../types/properties/propertyTypes';
import Title from '../Title';
import useTranslate from '../../../../customHooks/useTranslate';
import SearchBarTypeahead from '../../../components/SearchBarTypeahead';

interface CategoriesMenuProps {
    categories: ComplementaryServiceCategoryState[];
    idSelectedCategory: number;
    onSelectCategory: (idCategory: number) => void;
}
const CategoriesMenu = (props: CategoriesMenuProps) => {
    const { categories, idSelectedCategory, onSelectCategory } = props;
    const translate = useTranslate();

    return (
        <menu className='service__menu-container'>
            <Title
                text={'categories'}
                translated={true}
                className='text-secondary-color overflow-initial'
            />
            <SearchBarTypeahead
                options={categories.map(category => ({
                    id: category.id,
                    label: category.name,
                    value: category.name,
                }))}
                onSelect={option => {
                    if (option) {
                        onSelectCategory(parseInt(option.id.toString()));
                    }
                }}
                resetInputValueOnSelect={true}
                placeholder={translate('filter_categories')}
            />
            <ul className='service__menu-list'>
                <li
                    className={`service__menu-item${
                        idSelectedCategory === 0
                            ? ' service__menu-item--selected'
                            : ''
                    }`}
                    onClick={() => onSelectCategory(0)}
                >
                    {translate('your_hotel_services')}
                </li>
                {categories.map(category => (
                    <li
                        key={category.id}
                        className={`service__menu-item${
                            idSelectedCategory === parseInt(category.id)
                                ? ' service__menu-item--selected'
                                : ''
                        }`}
                        onClick={() => onSelectCategory(parseInt(category.id))}
                    >
                        {category.name}
                    </li>
                ))}
            </ul>
        </menu>
    );
};

export default CategoriesMenu;
